import React from 'react';
import './SupportButton.scss';
import { Icon } from '@innovationnorway/cl-react';
import useToggle from 'src/hooks/use-toggle';
import SupportButtonPopup from './SupportButtonPopup';
import { useTranslation } from 'react-i18next';
import ProgramRenderer from '../ProgramRenderer';
import { useUser } from 'src/features/authorization';

const SupportButton: React.FC = () => {
  const { isActive: showPopup, deactivate: deactivatePopup, activate: activatePopup } = useToggle();
  const { t: tCommon } = useTranslation();

  const { isUserLoggedIn, user } = useUser();

  if (isUserLoggedIn && user?.chosenClusterId) {
    return (
      <ProgramRenderer
        render={[
          {
            program: '*',
            children: (
              <>
                {showPopup ? (
                  <SupportButtonPopup show={showPopup} deactivate={() => deactivatePopup()} />
                ) : (
                  <div className="support">
                    <button
                      className="support__button"
                      aria-label={tCommon('contactSupport')}
                      onClick={() => activatePopup()}
                    >
                      <Icon
                        prefix="fasr"
                        iconName="message-question"
                        size="xl"
                        className={'support__button-icon'}
                      />
                    </button>
                  </div>
                )}
              </>
            ),
          },
          {
            program: 'one-way-in',
            children: null,
          },
        ]}
      />
    );
  } else {
    return <></>;
  }
};

export default SupportButton;
